import { createStandaloneToast } from '@chakra-ui/react';

const { toast } = createStandaloneToast();

export const showGlobalToast = (
  title: string,
  description: string,
  status: 'success' | 'error' | 'info' | 'warning'
) => {
  toast({
    title,
    description,
    status,
    duration: 5000,
    isClosable: true,
  });
};
